import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';

export const useGetLanguageAndConfig = (id: number) => {
  const fetchLanguageAndConfig = async () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response = await Axios.get<any>(
      `${GET_URL(id.toString()).languageAndConfig}`
    );
    return response.data;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useQuery<any, AxiosError<BaseError>>(
    ['languageAndConfig', id],
    fetchLanguageAndConfig,
    {
      enabled: id !== 0,
      useErrorBoundary: false
    }
  );
};
